import React, { memo } from 'react';
import Helmet from 'react-helmet';

import { RetainerHealthReport } from '../components/RetainerHealthReport';

/**
 * Retainer health report container component.
 */
const RetainerHealthReportContainer = () => (
  <div className="full-height">
    <Helmet title="Retainer Health Report" />
    <RetainerHealthReport />
  </div>
);

export default memo(RetainerHealthReportContainer);
